<template>
  <div>
    <v-layout wrap justify-end>
      <v-flex xs12 md10 xl8>
        <v-layout wrap>
          <v-flex xs12 text-left>
            <v-icon size="20px" color="#171717">mdi-format-align-left</v-icon>
            <span
              style="font-family:opensansbold;font-size:18px;color:#171717;"
              class="px-2"
            >Filters</span>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex py-2 xs12 text-left>
            <span style="font-family:opensanssemibold;font-size:18px;color:#171717;">Categories</span>
          </v-flex>
          <v-flex xs12 text-left>
            <v-list dense>
              <v-list-group v-for="(item,i) in categories" :key="i">
                <template v-slot:activator>
                  <v-list-item-title>
                    <span
                      style="font-family:opensanssemibold;font-size:14px;color:#464646;"
                      @click="setSubCategory(item)"
                    >{{item.name}}</span>
                  </v-list-item-title>
                </template>
                <v-list-item
                  sub-group
                  v-for="(subitem, j) in item.subcategory"
                  :key="j"
                  @click="1"
                  link
                >
                  <v-list-item-action>
                    <span
                      style="font-family:opensansregular;font-size:14px;color:#616161;"
                      @click="setCategory(item)"
                    >{{subitem.name}}</span>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex pt-2 xs12 text-left>
            <span style="font-family:opensanssemibold;font-size:18px;color:#171717;">Brands</span>
          </v-flex>
          <v-flex xs12 text-left>
            <v-radio-group v-model="brand" :mandatory="false" dense>
              <v-radio
                v-for="(item,i) in brands"
                :key="i"
                :label="item"
                :value="item"
                :ripple="false"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex pt-2 xs12 text-left>
            <span style="font-family:opensanssemibold;font-size:18px;color:#171717;">Price</span>
          </v-flex>
          <v-flex xs12 text-left>
            <v-range-slider
              v-model="priceRange"
              class="align-center"
              color="#63028F"
              track-color="#C6C6C6"
              :tick-size="10"
              hide-details
              :ripple="false"
              :max="filters.maxPrice"
            ></v-range-slider>
            <v-layout px-2 wrap>
              <v-flex xs6 text-left>
                <span
                  style="font-family:opensanssemibold;font-size:14px;color:#464646;"
                >₹ {{priceRange[0]}}</span>
              </v-flex>
              <v-flex xs6 text-right>
                <span
                  style="font-family:opensanssemibold;font-size:14px;color:#464646;"
                >₹ {{priceRange[1]}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["filters"],
  data() {
    return {
      ServerError: false,
      category: null,
      categories: [],
      brand: null,
      brands: ["Personal Care", "Home Care", "Baby Care", "Medicines"],
      priceRange: [0, this.filters.maxPrice],
    };
  },
  beforeMount() {
    this.getCategory();
  },
  watch: {
    priceRange() {
      this.getFilter();
    },
  },
  methods: {
    setSubCategory() {},
    setCategory() {},
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/category/getlist",
      }).then((response) => {
        this.categories = response.data.data;
      });
    },
    getFilter() {
      this.$emit("stepper", {
        priceRange: this.priceRange,
        category: this.category,
        brand: this.brand,
      });
    },
  },
};
</script>